import React from 'react';

export default function BookingTier({
  level,
  name,
  description,
  priceFrom,
  priceLabel = 'από',
  ctaText = 'Επιλογή',
  href = '#',
  featured = false,
  featuredLabel = 'MASTER',
  className = '',
}) {
  return (
    <div 
      className={`
        relative bg-warm-black border rounded-[22px] p-[26px]
        grid grid-cols-1 md:grid-cols-[auto_1fr_auto_auto] gap-6 items-center
        transition-all duration-400 cursor-pointer
        ${featured 
          ? 'border-gold-light/50' 
          : 'border-gold-light/15 hover:border-gold-light/40 hover:translate-x-1.5'
        }
        ${className}
      `}
    >
      {featured && (
        <>
          {/* Subtle gold left accent bar */}
          <div className="absolute left-0 top-[20%] bottom-[20%] w-[3px] rounded-full bg-gold-bg" />
          <span className="absolute -top-2.5 left-6 bg-gold-bg text-warm-black px-3 py-1 rounded-pill text-[11px] tracking-[1.5px] font-semibold">
            {featuredLabel}
          </span>
        </>
      )}
      
      <div className="font-serif italic text-[22px] text-gold-light w-[70px]">
        {level}.
      </div>
      
      <div>
        <div className="font-serif text-[21px] text-cream mb-[3px] font-medium">
          {name}
        </div>
        <div className="text-[13px] text-cream/80 leading-[1.4]">
          {description}
        </div>
      </div>
      
      <div className="text-left md:text-right">
        <div className="text-[11px] tracking-wider uppercase text-gold-light mb-1">
          {priceLabel}
        </div>
        <div className="font-serif text-[28px] text-cream font-medium">
          €{priceFrom}
        </div>
      </div>
      
      <a 
        href={href}
        className={`
          inline-flex items-center justify-center
          px-[22px] py-3 rounded-pill text-tiny font-semibold tracking-wide
          transition-all duration-300 hover:scale-105
          ${featured ? 'bg-gold-bg text-warm-black hover:bg-gold-light' : 'bg-cream text-warm-black hover:bg-gold-light'}
        `}
      >
        {ctaText}
      </a>
    </div>
  );
}